export const resumeData = {
  personal: {
    name: "SEAN ROUMAYA",
    firstName: "Sean",
    lastName: "Roumaya",
    title: "Customer Support & Website Content Specialist",
    subTitle: "",
    email: "xroumaya@gmail.com",
    phone: "(480) 415-9396",
    addressLine1: "",
    city: "Surprise",
    state: "AZ",
    zip: "85374",
    location: "Surprise, AZ",
  },
  summary:
    "Customer Support & Website Content Specialist with 8+ years' experience across Amazon and eBay storefronts. Highly attentive to detail with a strong focus on client relations. Manage ecommerce customer support, product listing optimization, and CRM records in logistics platforms, cutting support issues and corrections by over 20%. Proficient in Mac & PC, utilizing WordPress and Advanced Photoshop to streamline workflows and deliver precise communications across email, chat, and phone.",
  skills: [
    {
      category: "Customer Support & Operations",
      items: [
        "Customer Support (email/chat)",
        "Client Relations & Communication",
        "Returns & Refunds Processing",
        "CRM & Logistics Platform Management",
      ],
    },
    {
      category: "Ecommerce & Marketplace Management",
      items: [
        "Amazon & eBay Storefront Management",
        "Product Listing Optimization",
        "Order Fulfillment Coordination",
      ],
    },
    {
      category: "Technical & Creative Skills",
      items: [
        "Front-end Website Design",
        "WordPress Website Management",
        "Hosting & Domain Management",
        "Advanced Adobe Photoshop",
        "Pre-press & Print Production Knowledge",
        "Mac & PC Proficient",
      ],
    },
    {
      category: "Automation & Emerging Tools",
      items: [
        "AI-assisted workflows & automation",
        "Workflow optimization using AI tools",
      ],
    },
    {
      category: "Additional Skills",
      items: [
        "Typing Speed: 60 WPM",
        "Strong Attention to Detail",
      ],
    }
  ],
  experience: [
    {
      role: "Review Manager & Freelance Web Designer",
      company: "StarStack",
      location: "Remote",
      period: "01/2026 - Present",
      highlights: [
        "Manage online reviews and reputation for small businesses, monitoring feedback across platforms and crafting professional responses that strengthen brand trust and customer relationships.",
        "Design and develop freelance websites for small businesses and independent clients, delivering clean, functional sites tailored to each client's brand and goals.",
      ],
    },
    {
      role: "Customer Service Delivery Advocate",
      company: "Carvana",
      location: "Tolleson, AZ",
      period: "09/2023 - 09/2025",
      highlights: [
        "Managed end-to-end customer delivery experiences for ecommerce vehicle orders to residential, office, and event locations, planning efficient neighborhood routes that maintained 98% on-time performance and reduced average delivery time by 15%.",
        "Optimized daily delivery operations by adjusting routes in real time based on traffic, customer priorities, and logistics platform data, improving route efficiency by 20% and cutting delivery delays by 25%.",
        "Handled customer service interactions at the door with professional communication and CRM-style documentation, resolving basic service issues, reducing repeat complaints by 30%, and contributing to a 4.8/5 average rating and customer satisfaction scores above 95%.",
        "Maintained accurate digital delivery records and pre-delivery communication while operating commercial and light-duty vehicles with 100% adherence to safety standards and less than 1% delivery error rate, supporting timely, accurate ecommerce fulfillment.",
      ],
    },
    {
      role: "Marketing Assistant",
      company: "Chikpea",
      location: "Troy, MI",
      period: "08/2019 - 06/2023",
      highlights: [
        "Executed digital marketing initiatives and online reputation management, strengthening customer perception and supporting ecommerce customer support goals.",
        "Managed online reviews and customer feedback, drafting professional customer communications that improved response quality and brand trust.",
        "Created digital and print promotional materials using Photoshop and pre‑press knowledge, aligning assets with WordPress content needs.",
        "Supported multi‑channel promotional campaigns, coordinating messaging across email support and chat support to maintain consistent communication.",
      ],
    },
    {
      role: "Online Store & Customer Support Specialist",
      company: "CMC Midwest (Amazon & eBay)",
      location: "Southfield, MI",
      period: "03/2016 - 08/2019",
      highlights: [
        "Managed Amazon and eBay storefronts end‑to‑end, overseeing ecommerce customer support and daily digital operations.",
        "Optimized product listings for visibility and conversions, improving search performance and reducing customer inquiries related to unclear information.",
        "Handled customer inquiries, returns, and refunds across email support, chat support, and phone support, maintaining high satisfaction and repeat purchases.",
        "Maintained accurate digital records and inventory details across ecommerce and logistics platforms, supporting fast order resolution and reduced support issues.",
      ],
    },
  ],
  additionalExperience: [
    {
      company: "Tech Clinic",
      role: "Graphic & Pre-Press Specialist",
      location: "MI",
      period: "2010 - 2015",
      bullet: "Provided graphic design, pre-press formatting, and technical support services for various print and digital projects."
    },
    {
      company: "Mobile Boards",
      role: "Pre-Press & Graphic Designer",
      location: "MI",
      period: "2005 - 2010",
      bullet: "Designed and produced large-format graphics and mobile advertising materials utilizing advanced pre-press knowledge."
    },
    {
      company: "C&G Newspapers",
      role: "Pre-Press Technician",
      location: "Warren, MI",
      period: "1998 - 2005",
      bullet: "Managed pre-press production, layout adjustments, and graphic design for high-volume print publications."
    }
  ],
  education: {
    degree: "High School in General Studies",
    school: "Sterling Heights High School",
    location: "Sterling Heights, MI",
  },
};